import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FastForwardOutlinedIcon from '@mui/icons-material/FastForwardOutlined';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Box,
  Container,
  Grid,
  Link,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { useState } from 'react';

import ExemptSubMenu from '@/components/nav/ExemptSubMenu';
import ComingSoonPopup from '@/components/ui/ComingSoonPopup';
import Hidden from '@/components/ui/TzoHidden';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';
// import type { LayoutWrapperContents } from '@/types/LayoutWrapperContents';

const ExemptArizona = () => {
  const [open, setOpen] = useState(false);

  // const layoutWrapperContents: LayoutWrapperContents = {
  //   Heading: `Extend your business tax return deadline with Form 7004.`,
  //   SubHeading:
  //     'E-file now and get more time to ensure accuracy. File now for peace of mind.',
  //   CtaText: 'E-file Form 7004 Now',
  //   CtaSubHeading: `Takes 3 steps and less than 5 minutes`,
  //   CtaURL: `${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=sticky`,
  //   isActive: true,
  // };

  return (
    <AppLayout
      //  LayoutWrapperContents={layoutWrapperContents}
      meta={
        <Meta
          title="Montana Non-Profit State Filing Requirements & Deadlines"
          description="Learn Montana’s non-profit filing requirements, deadlines, and compliance rules. Ensure your organization stays in good standing with the state. "
          keywords=" "
          canonical="nonprofit-taxes/montana-state-filing-requirements/"
          // jsonLdPricing="2.49"
          jsonLdAggregateRatingValue="5.00"
          jsonLdAggregateRatingCount="2183"
          ogShareImg="assets/images/exempt-share-img.png"
        />
      }
    >
      <ExemptSubMenu />
      <ComingSoonPopup open={open} setOpen={setOpen} />

      {/* <Container maxWidth="md">
        <Box sx={{ px: 2, mt: 3, mx: 0 }}>
          <Alert
            severity="warning"
            icon={<WarningIcon sx={{ fontSize: 30 }} />}
            sx={{ borderRadius: 3 }}
          >
            <AlertTitle
              sx={{ fontSize: { xs: 18, sm: 20, md: 22 }, fontWeight: 600 }}
            >
              Attention! Final Day to E-File Form W-2!
            </AlertTitle>

            <Typography
              variant="body1"
              sx={{ fontSize: { xs: 16, sm: 17, md: 18 } }}
            >
              Don&apos;t miss the deadline! Today is the <b>Last Day</b> to
              Submit Your <b>Form W-2</b> Electronically!
            </Typography>
          </Alert>
        </Box>
      </Container> */}
      <Container maxWidth="xl" component="section">
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={3}
          sx={{ px: { xs: 2, md: 0 } }}
        >
          <Hidden mdDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
                width: '100%',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source srcSet="/assets/images/1099-mt-landing-img.webp" />
                <source srcSet="/assets/images/1099-mt-landing-img.png" />
                <img
                  src="/assets/images/1099-mt-landing-img.png"
                  alt="Montana State Filing Requirements"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
              </picture>
            </Box>
          </Hidden>

          <Box
            sx={{
              textAlign: { xs: 'center', md: 'left' },
              alignItems: 'center',
              display: 'flex',
              width: '100%',
              maxWidth: { xs: 'inherit', lg: 770 },
              minWidth: { xs: 'inherit', md: 530 },
              pl: { xs: 0, md: 6, lg: 8, xl: 12 },
              justifyContent: 'center',
            }}
          >
            <Box
              component="div"
              sx={{ mt: { xs: 2, sm: 4, md: 5 }, mb: { xs: 2, sm: 4, md: 5 } }}
            >
              <Typography
                variant="h1"
                sx={{
                  fontSize: { lg: 40, md: 30, sm: 24, xs: 24 },
                  fontWeight: 600,
                  color: '#374151',
                  mb: 3,
                }}
              >
                <span className="highlight-container">
                  <span className="highlight">Montana State </span>
                </span>{' '}
                Filing
                <Hidden mdDown>
                  <br />
                </Hidden>{' '}
                Requirements
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  mb: 2,
                }}
              >
                Nonprofits in Montana must comply with specific state
                requirements to maintain their good standing and tax-exempt
                status.
              </Typography>

              {/* <Stack
                direction={{ xs: 'column-reverse', md: 'row' }}
                spacing={{ xs: 1, md: 6 }}
                justifyContent={{
                  xs: 'center',
                  md: 'flex-start',
                }}
                alignItems="center"
                sx={{ mt: 4 }}
              >
                <Box sx={{ textAlign: 'center', mr: { xs: 0, md: 4 } }}>
                  <Button
                    variant="contained"
                    className="btn-primary"
                    sx={{
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=montana`}
                  >
                    E-File Now
                  </Button>
                 
                </Box>
              </Stack> */}
            </Box>
          </Box>
          <Hidden mdUp smDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-end',
                width: '100%',
                backgroundPosition: 'center center !important',
                mt: '0 !important',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source srcSet="/assets/images/1099-mt-landing-img-sm.webp" />
                <source srcSet="/assets/images/1099-mt-landing-img-sm.png" />
                <img
                  src="/assets/images/1099-mt-landing-img-sm.png"
                  alt="Montana State Filing Requirements "
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
              </picture>
            </Box>
          </Hidden>
        </Stack>
      </Container>
      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ pt: 4, pb: 4 }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
              fontWeight: 600,
              mb: 2,
              pt: 5,
              textAlign: 'center',
            }}
          >
            Required Non-profit Forms
          </Typography>
          <Typography
            variant="body1"
            sx={{
              fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
              fontWeight: 400,
              mb: 2,
              textAlign: 'center',
            }}
          >
            Non-profits in Montana are required to complete several forms as
            part of their compliance obligations.
          </Typography>
          <Grid container spacing={2}>
            <Grid
              size={12}
              sx={{
                px: { md: 3, sm: 0, xs: 0 },
                textAlign: 'center',
                alignItems: 'center',
              }}
            >
              <Box component="div" sx={{ mb: 5 }}>
                <TableContainer
                  sx={{ border: '1px solid #828282', borderRadius: 2 }}
                >
                  <Table sx={{}} aria-label="Due Date Chart">
                    <TableHead>
                      <TableRow sx={{ backgroundColor: '#ccc' }}>
                        <TableCell
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            fontSize: 16,
                          }}
                        >
                          Montana Forms
                        </TableCell>

                        <TableCell
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,

                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            fontSize: 16,
                          }}
                        >
                          Federal Forms (Required for State Compliance)
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',

                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          <ul>
                            <li style={{ marginBottom: 8 }}>
                              <Link
                                href="https://sosmt.gov/business/"
                                target="_blank"
                                sx={{ color: '#0202ff' }}
                              >
                                Business & UCC Services
                              </Link>
                            </li>

                            <li style={{ marginBottom: 8 }}>
                              <Link
                                href="https://biz.sosmt.gov/forms/business"
                                target="_blank"
                                sx={{ color: '#0202ff' }}
                              >
                                Business Forms
                              </Link>{' '}
                            </li>
                            <li style={{ marginBottom: 8 }}>
                              <Link
                                href="https://mtrevenue.gov/wp-content/uploads/dlm_uploads/2024/12/2024_Corporate_Income_Tax_Return-Form_CIT-1.pdf"
                                target="_blank"
                                sx={{ color: '#0202ff' }}
                              >
                                Montana Corporate Income Tax Return
                              </Link>{' '}
                            </li>
                          </ul>
                        </TableCell>

                        <TableCell
                          sx={{
                            textAlign: 'left',
                            backgroundColor: '#fff',
                          }}
                        >
                          <ul>
                            <li style={{ marginBottom: 8 }}>
                              <span style={{ fontWeight: 600 }}>
                                {' '}
                                Form 1023 (Application for Recognition of
                                Exemption Under Section 501(c)(3) of the
                                Internal Revenue Code):
                              </span>{' '}
                              For most charitable organizations
                            </li>

                            <li style={{ marginBottom: 8 }}>
                              <span style={{ fontWeight: 600 }}>
                                {' '}
                                Form 1024 (Application for Recognition of
                                Exemption Under Section 501(a) or Section 521 of
                                the Internal Revenue Code):
                              </span>{' '}
                              For other types of nonprofits.
                            </li>
                            <li style={{ marginBottom: 8 }}>
                              <Link
                                href="/tax-exempt/e-file-irs-form-990/"
                                sx={{ color: '#0202ff' }}
                              >
                                <span style={{ fontWeight: 600 }}>
                                  {' '}
                                  Form 990 (Return of Organization Exempt From
                                  Income Tax):
                                </span>
                              </Link>{' '}
                              Annual information return for tax-exempt
                              organizations.
                            </li>
                          </ul>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Container
        component="section"
        maxWidth="lg"
        sx={{ pt: 6, pb: 6, textAlign: 'center' }}
      >
        <Grid
          container
          spacing={2}
          direction={{ md: 'row', xs: 'column-reverse' }}
          sx={{ pt: 5, pb: 2 }}
        >
          <Grid size={{ xs: 12, sm: 6 }}>
            <Box
              sx={{
                px: { md: 0, sm: 0, xs: 2 },
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: { md: 'left', xs: 'center' },
              }}
            >
              {' '}
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: { md: 3, sm: 1, xs: 0 },
                  pt: { md: 0, sm: 3 },
                  textAlign: { md: 'left', sm: 'center' },
                }}
              >
                State Filing Requirements for Non-Profits
              </Typography>
              <Typography variant="body1" sx={{ mb: 1 }}>
                Establishing a non-profit in Montana involves several key steps
                with the Montana Secretary of State. These initial filings lay
                the foundation for your organization&apos;s legal standing and
                ability to operate.
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                Here&apos;s a breakdown of the key obligations
              </Typography>
              <Box
                component="ol"
                sx={{ mb: 2, textAlign: 'left', '& li': { mb: 1.5 } }}
              >
                <li>
                  <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                    Initial Registration
                  </Typography>

                  <Typography variant="body1" sx={{ mb: 2 }}>
                    All non-profit organizations intending to operate in Montana
                    must register with the Montana Secretary of State. This
                    typically involves filing Articles of Incorporation (for
                    corporations) or similar organizational documents (for other
                    entity types).
                  </Typography>
                </li>
                <li>
                  <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                    Appoint a Registered Agent
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 1 }}>
                    Designate a registered agent with a physical address in
                    Montana who can receive legal documents on behalf of the
                    organization.
                  </Typography>
                </li>
                <li>
                  <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                    Federal Tax Exemption Recognition
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 1 }}>
                    While Montana doesn&apos;t have its own state-level tax
                    exemption application, securing 501(c)(3) status from the
                    IRS is often a prerequisite for many funding opportunities
                    and establishes your organization as a tax-exempt entity at
                    the federal level.
                  </Typography>
                </li>
                <li>
                  <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                    Annual Report Filing
                  </Typography>

                  <Typography variant="body1" sx={{ mb: 2 }}>
                    Non-profit corporations are required to file an annual
                    report with the Montana Secretary of State to keep their
                    registration active and provide updated information about
                    the organization.
                  </Typography>
                </li>{' '}
                <li>
                  <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                    Charitable Solicitation Registration (if applicable)
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 2 }}>
                    If your non-profit intends to solicit charitable
                    contributions from Montana residents, you will likely need
                    to register with the Montana Department of Justice. Certain
                    exemptions may apply.
                  </Typography>
                </li>{' '}
                <li>
                  <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                    Business License (if applicable)
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 2 }}>
                    Depending on the specific activities of your non-profit, you
                    may need to obtain a business license from the Montana
                    Department of Revenue or other local agencies.
                  </Typography>
                </li>{' '}
              </Box>
            </Box>
          </Grid>
          <Grid
            size={{ xs: 12, sm: 6 }}
            sx={{
              textAlign: { md: 'left', sm: 'center', xs: 'center' },
              alignItems: 'center',
              justifyContent: 'center',
              display: 'flex',
            }}
          >
            <Box>
              <picture>
                <source srcSet="/assets/images/who-file-mt-img.webp" />
                <source srcSet="/assets/images/who-file-mt-img.png" />
                <img
                  src="/assets/images/who-file-mt-img.png"
                  alt="State Filing Requirements for Non-Profits"
                  className="img-responsive img-shadow"
                  loading="lazy"
                  width={500}
                  height={500}
                />
              </picture>
            </Box>
          </Grid>
        </Grid>
      </Container>
      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            sx={{
              my: { xs: 2, sm: 6, md: 8 },
              textAlign: { md: 'left', sm: 'center', xs: 'center' },
            }}
            className="MuiGrid-root-width"
          >
            <Grid
              size={12}
              sx={{
                textAlign: 'left',
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  py: 5,
                  borderRadius: 5,
                  backgroundColor: '#fff',
                  maxWidth: 800,
                }}
              >
                <Box>
                  <Typography
                    variant="h2"
                    sx={{
                      fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                      fontWeight: 600,
                      mb: 3,
                      textAlign: 'center',
                      lineHeight: 1.5,
                    }}
                  >
                    Tax Exemption Requirements
                  </Typography>
                  <Typography variant="body1" sx={{ textAlign: 'center' }}>
                    To maintain tax-exempt status in{' '}
                    <span style={{ fontWeight: 600 }}> Montana</span>,
                    organizations must:
                  </Typography>
                  <Box
                    component="ul"
                    sx={{
                      listStyleType: 'none',
                      paddingLeft: 0,
                      textAlign: 'left',
                      ml: { xs: 0, sm: 3 },
                      '& li svg': { float: 'left', fontSize: 27 },
                    }}
                  >
                    <li style={{ marginBottom: 12 }}>
                      <FastForwardOutlinedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />
                      No general sales tax in Montana—
                      <span style={{ fontWeight: 600 }}>
                        no sales tax exemption needed.
                      </span>
                    </li>
                    <li style={{ marginBottom: 12 }}>
                      <FastForwardOutlinedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />
                      <span style={{ fontWeight: 600 }}> Annual Filing:</span>{' '}
                      File Form 990 with the IRS.
                    </li>
                    <li style={{ marginBottom: 12 }}>
                      <FastForwardOutlinedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />
                      If fundraising, registration with{' '}
                      <span style={{ fontWeight: 600 }}>
                        Montana Department of Justice, Office of Consumer
                        Protection
                      </span>{' '}
                      may be needed.
                    </li>
                    <li style={{ marginBottom: 12 }}>
                      <FastForwardOutlinedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        Income Tax Exemption:
                      </span>{' '}
                      Because Montana matches the federal income tax code, a
                      501(c)(3) org is generally exempt from state income tax.
                    </li>
                    <li style={{ marginBottom: 12 }}>
                      <FastForwardOutlinedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />
                      Submit financial disclosures if raising funds from the
                      public.
                    </li>
                  </Box>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        // className="dotted-curve"
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12} className="responsive">
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Filing Deadlines for Non-Profit Forms
              </Typography>
              <Typography variant="body1" sx={{ textAlign: 'center' }}>
                Adhering to filing deadlines is essential to avoid penalties and
                maintain compliance.
              </Typography>
            </Grid>
            <Grid size={12} className="responsive">
              {' '}
              <Typography variant="body1" sx={{ mb: 1 }}>
                Below are the key deadlines for non-profit filings in Montana:
              </Typography>
              <Box component="div" sx={{ mb: 2 }}>
                <TableContainer
                  sx={{ border: '1px solid #828282', borderRadius: 2, mb: 4 }}
                >
                  <Table sx={{}} aria-label="Due Date Chart">
                    <TableHead>
                      <TableRow sx={{ backgroundColor: '#ccc' }}>
                        <TableCell
                          colSpan={2}
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,

                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            fontSize: 16,
                          }}
                        >
                          Montana Filing Deadlines
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                            fontWeight: 600,
                          }}
                        >
                          Articles of Incorporation for Nonprofit Corporations
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid #828282',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          Upon establishing the nonprofit
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                            fontWeight: 600,
                          }}
                        >
                          Montana Tax-Exempt Status Request Form (Form EXPT)
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid #828282',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          After receiving IRS Determination Letter
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                            fontWeight: 600,
                          }}
                        >
                          Montana Annual Report
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid #828282',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          Annually by April 15th
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                            fontWeight: 600,
                          }}
                        >
                          Charitable Solicitation Renewal
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid #828282',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          Annually, based on your original registration date.
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',

                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                            fontWeight: 600,
                          }}
                        >
                          Montana Form CIT
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          Due by the 15th day of the 5th month after the fiscal
                          year ends.
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>

                <TableContainer
                  sx={{ border: '1px solid #828282', borderRadius: 2, mb: 4 }}
                >
                  <Table sx={{}} aria-label="Due Date Chart">
                    <TableHead>
                      <TableRow sx={{ backgroundColor: '#ccc' }}>
                        <TableCell
                          colSpan={2}
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,

                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            fontSize: 16,
                          }}
                        >
                          Federal Deadlines
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                            fontWeight: 600,
                            width: 400,
                          }}
                        >
                          Form 990 Series
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid #828282',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          Due on the 15th day of the 5th month after the
                          organization&apos;s accounting period ends <br />
                          <b>Example:</b> For calendar year organizations, Form
                          990 is due by May 15
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',

                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                            fontWeight: 600,
                            width: 400,
                          }}
                        >
                          Form 1023/1023-EZ
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          Must be filed within 27 months of incorporation to
                          receive retroactive exemption to the date of
                          incorporation
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Grid>
            {/* <Grid size={12}>
              <Box component="div" sx={{ textAlign: 'center' }}>
                <Button
                  variant="contained"
                  sx={{
                    mt: 4,
                    mb: 2,
                    transition: 'all 0.3s ease 0s',
                    '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                  }}
                  className="btn-primary"
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=montana`}
                >
                  E-file State Filing
                </Button>
              </Box>
            </Grid> */}
          </Grid>
        </Container>
      </Grid>
      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ py: 6 }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
              fontWeight: 600,
              mt: 4,
              mb: 3,
              textAlign: 'center',
            }}
          >
            Registration & Annual Filing (Non-Profits)
          </Typography>
          <Typography variant="body1" sx={{ textAlign: 'center' }}>
            To operate legally as a non-profit in Montana, organizations must
            file the Articles of Incorporation and pay the $20 filing fee.
          </Typography>

          <Grid
            container
            spacing={2}
            sx={{ mt: 4, mb: 4, px: { md: 11, sm: 2, xs: 0 } }}
          >
            <Grid size={{ xs: 12, sm: 6 }} className="responsive">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 2,
                  textAlign: 'left',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  // display: 'flex',
                  // gap: 2,
                  // alignItems: 'start',
                  backgroundColor: '#fff',
                }}
              >
                <Box sx={{ p: 2 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      fontWeight: 600,
                      my: 1,
                    }}
                  >
                    Initial Registration
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                    1. Nonprofit Corporation Registration
                  </Typography>

                  <Typography variant="body1" sx={{ mb: 2 }}>
                    Begin with the Montana Secretary of State. File your
                    Articles of Incorporation and pay the associated filing fee.
                    Ensure your organization&apos;s name is available and
                    complies with Montana regulations.
                  </Typography>

                  <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                    2. Obtaining an EIN
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 2 }}>
                    After incorporating with the state, you will need to obtain
                    an Employer Identification Number (EIN) from the IRS.
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                    3. Develop Bylaws and Hold Initial Board Meeting
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 2 }}>
                    Create organizational bylaws that outline the
                    nonprofit&apos;s governance structure, though these are not
                    filed with the state. Also, conduct an initial meeting to
                    appoint directors, adopt bylaws, and authorize pursuit of
                    tax-exempt status.
                  </Typography>

                  <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                    4. Applying for Federal Tax-Exempt Status
                  </Typography>

                  <Typography variant="body1" sx={{ mb: 0 }}>
                    If your non-profit intends to be recognized as tax-exempt
                    under section 501(c)(3) of the Internal Revenue Code, you
                    will need to apply to the IRS. This typically involves
                    filing Form 1023 or Form 1023-EZ, along with the required
                    filing fee.
                  </Typography>
                </Box>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }} className="responsive">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 2,
                  textAlign: 'left',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  // display: 'flex',
                  // gap: 2,
                  // alignItems: 'start',
                  backgroundColor: '#fff',
                }}
              >
                <Box sx={{ p: 2 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      fontWeight: 600,
                      my: 1,
                    }}
                  >
                    Annual Filing Requirements
                  </Typography>

                  <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                    1. Annual Report
                  </Typography>

                  <Typography variant="body1" sx={{ mb: 2 }}>
                    File your annual report online or by mail by the stated
                    deadline. Accurately update all relevant information about
                    your organization&apos;s directors, address, and contact
                    information.
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                    2. Charitable Solicitation
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 2 }}>
                    Thoroughly review the Montana Department of Justice
                    requirements and determine if your organization is required
                    to register. Understand the reporting requirements and
                    renewal process.
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                    3. Filing IRS Form 990
                  </Typography>

                  <Typography variant="body1" sx={{ mb: 2 }}>
                    Tax-exempt organizations must file the appropriate IRS Form
                    990 series return annually with the Internal Revenue
                    Service. The deadline is generally the 15th day of the 5th
                    month after the end of your fiscal year.
                  </Typography>

                  <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                    4. Public Disclosure Requirements
                  </Typography>

                  <Typography variant="body1" sx={{ mb: 2 }}>
                    Make Form 990 available for public inspection. Provide
                    copies of exemption application and returns when requested
                    and maintain transparency in operations and financials.
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                    5. Keep Corporate Records
                  </Typography>

                  <Typography variant="body1" sx={{ mb: 0 }}>
                    Maintain proper corporate records, meeting minutes, and
                    financial records as required by Montana nonprofit
                    corporation law.
                  </Typography>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Box
        component="section"
        sx={{
          backgroundColor: '#1da94a',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
      >
        <Typography
          variant="h2"
          color="white"
          sx={{
            fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
            fontWeight: 600,
            mb: 3,
            lineHeight: 1.5,
          }}
        >
          Trusted Annual Filing Solutions
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            color: '#f3f3f3',
            mb: 2,
            lineHeight: 1.5,
          }}
        >
          TaxZerone supports nonprofit organizations with compliant and secure
          tax reporting.
        </Typography>
        {/* <Box component="div" sx={{ margin: 'auto' }}>
          <Button
            variant="contained"
            sx={{
              mt: { xs: 0, sm: 4 },
              mb: { xs: 0, md: 0 },
              color: '#444',
              transition: 'all 0.3s ease 0s',
              '&:hover, &active': {
                backgroundColor: '#213e99 !important',
                color: '#fff',
                transform: 'scale(1.1)',
              },
            }}
            className="btn-secondary-white"
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=montana`}
          >
            E-File Now
          </Button>
        </Box> */}
      </Box>
      <Container component="section" maxWidth="lg">
        <Grid
          container
          spacing={2}
          m={2}
          direction="row"
          justifyContent="center"
          className="MuiGrid-root-width"
          sx={{ my: { xs: 0, sm: 2 } }}
        >
          <Grid
            size={{ xs: 12, sm: 10, md: 9 }}
            textAlign="left"
            my={{ xs: 2, sm: 5 }}
            mb={3}
            className="responsive"
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 5,
                textAlign: 'center',
              }}
            >
              Frequently Asked Questions
            </Typography>
            <Box
              component="div"
              sx={{ mb: 5 }}
              itemScope
              itemType="https://schema.org/FAQPage"
            >
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  1. Do I need to register my non-profit with the state even if
                  it&apos;s a purely volunteer-run organization?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography variant="body1" itemProp="text" sx={{ mt: 1 }}>
                    Generally, yes. If you are operating as a corporation or
                    another formally recognized entity, you&apos;ll need to
                    register with the Montana Secretary of State, even if you
                    have no paid staff.
                  </Typography>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  2. Do nonprofits need a business license in Montana?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1" sx={{ mt: 1 }}>
                      <b>No</b>, Montana does not require nonprofits to obtain a
                      state-level business license.
                    </Typography>
                    <Typography variant="body1" sx={{ mt: 1 }}>
                      However, local municipalities may have their own
                      requirements, so it&apos;s essential to check with the
                      specific city and county where the nonprofit operates to
                      determine if any local licenses or permits are needed.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  3. Where can I find the Montana Statutes that govern nonprofit
                  corporations?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1" sx={{ mt: 1 }}>
                      Montana&apos;s non-profit corporation laws can be found in
                      Title 35, Chapter 2 of the Montana Code Annotated (MCA).
                      You can access the MCA online through the{' '}
                      <Link
                        href="https://www.legmt.gov/lsd/"
                        target="_blank"
                        sx={{ color: '#0202ff' }}
                      >
                        Montana Legislative Services Division
                      </Link>{' '}
                      website.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  4. Can my nonprofit be exempt from property taxes in Montana?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1" sx={{ mt: 1 }}>
                      <b>Yes</b>, nonprofits may qualify for property tax
                      exemption if the property is used exclusively for
                      nonprofit purposes. You must apply through your county
                      assessor&apos;s office, and this exemption is not
                      automatic with your nonprofit status.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  5. How do I change my nonprofit&apos;s registered agent in
                  Montana?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1" sx={{ mt: 1, mb: 1 }}>
                      To change a nonprofit&apos;s registered agent in Montana,
                      you need to file a Registered Agent/Office Change by
                      Entity form with the Montana Secretary of State.
                    </Typography>
                    <Typography variant="body1" sx={{ mt: 1, mb: 1 }}>
                      The Montana Statement of Change must be submitted by
                      online and has no fee to file. However, you can pay $20
                      for one day service or $100 for one-hour processing.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Alert severity="info" icon={false} sx={{ borderRadius: 2 }}>
                <Accordion
                  defaultExpanded
                  sx={{
                    '&.MuiAccordion-root::before, &.MuiAccordion-root.Mui-expanded::before':
                      {
                        background: 'none !important',
                      },
                    '&.MuiAccordion-root': { background: 'none !important' },
                  }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls=""
                    id=""
                    sx={{
                      px: 0,
                      m: 0,
                      justifyContent: 'flex-start',
                      '& .MuiAccordionSummary-content, & .MuiAccordionSummary-content.Mui-expanded':
                        { m: '0 !important', flexGrow: 0 },
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{
                        fontWeight: 600,
                        color: '#014361',
                        fontSize: 16,
                      }}
                    >
                      Sources and References
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails sx={{ p: 0 }}>
                    <Typography variant="body2" sx={{ mt: 1 }}>
                      This resource guide is compiled from authoritative
                      sources, including:
                    </Typography>
                    <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.5 } }}>
                      <li>
                        <Link
                          href="https://sosmt.gov/"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          Montana Secretary of State
                        </Link>
                      </li>
                      <li>
                        {' '}
                        <Link
                          href="https://dojmt.gov/"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          Montana Department of Justice
                        </Link>
                      </li>{' '}
                      <li>
                        {' '}
                        <Link
                          href="https://mtrevenue.gov/"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          Montana Department of Revenue
                        </Link>
                      </li>{' '}
                      <li>
                        {' '}
                        <Link
                          href="https://sosmt.gov/business/"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          Montana Secretary of State – Business Services
                        </Link>
                      </li>{' '}
                      <li>
                        {' '}
                        <Link
                          href="https://mtnonprofit.org/"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          Montana Nonprofit Association
                        </Link>
                      </li>{' '}
                      <li>
                        {' '}
                        <Link
                          href="https://dli.mt.gov/"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          Montana Department of Labor and Industry
                        </Link>
                      </li>{' '}
                      <li>
                        {' '}
                        <Link
                          href="https://www.irs.gov/"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          Internal Revenue Services
                        </Link>
                      </li>{' '}
                    </Box>
                  </AccordionDetails>
                </Accordion>
              </Alert>
            </Box>{' '}
          </Grid>
        </Grid>
      </Container>
    </AppLayout>
  );
};

export default ExemptArizona;
